import React, { useState } from 'react';
import cx from 'classnames';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
//constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
//icons
import { ARROW_DOWN, ARROW_DOWN_FILLED, ARROW_UP_FILLED, } from '@/constants/icons/unicode';
//styles
import style from './Table.module.scss';
const getIcon = (key, sortState) => {
    if (sortState.sortBy === key) {
        if (sortState.descending)
            return ARROW_DOWN_FILLED;
        return ARROW_UP_FILLED;
    }
    return ARROW_DOWN;
};
const Table = ({ columns, data, renderRow, onSort, deleteRowAllowed, renderHeader, classNames, FirstColumn, firstColumnProps, renderPlaceholder, rowContainerRef, showHeader = true, }) => {
    if (!columns.length)
        return null;
    const [sortState, setSortState] = useState(() => ({
        sortBy: columns[0].key,
        descending: false,
    }));
    const handleSort = (sortData) => {
        let descending = true;
        if (sortState.sortBy === sortData.sortBy) {
            if (sortState.descending)
                descending = false;
            else {
                // default order -> sort by first column in ascending order
                sortData.sortBy = columns[0].key;
                descending = false;
            }
        }
        setSortState(Object.assign(Object.assign({}, sortData), { descending }));
        onSort(Object.assign(Object.assign({}, sortData), { descending }));
    };
    return (React.createElement("div", { className: cx(style.container, classNames === null || classNames === void 0 ? void 0 : classNames.container) },
        showHeader && (React.createElement("div", null,
            React.createElement("ul", { className: cx(style.tableRow, style.headerList, classNames === null || classNames === void 0 ? void 0 : classNames.header) },
                columns.map((column, index) => {
                    return renderHeader ? (renderHeader(column)) : index === 0 && FirstColumn ? (React.createElement(FirstColumn, Object.assign({}, firstColumnProps))) : (React.createElement("li", { key: column.key, className: cx(column.className, {
                            [style.headerCellSortable]: column.sortable,
                            [style.headerCellLeft]: index === 0,
                        }), onClick: () => column.sortable &&
                            handleSort({ sortBy: column.key }), style: { width: column.width } },
                        React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Low_Emphasis, className: style.tableHeader },
                            column.title,
                            column.sortable && (React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Low_Emphasis }, String.fromCharCode(getIcon(column.key, sortState)))))));
                }),
                deleteRowAllowed && (React.createElement("li", { className: style.deleteHeader }))))),
        React.createElement("div", { ref: rowContainerRef, className: cx(style.rows, classNames === null || classNames === void 0 ? void 0 : classNames.tableBody) },
            data.map((row, index) => {
                return renderRow(row, index);
            }),
            data.length === 0 && renderPlaceholder && renderPlaceholder())));
};
export default Table;
